import { setFetching,setCurrentUser,setGlobalError,updateAccessToken } from './appReducer';
import {authAPI} from '../../api/api';

let initialState = {
    users: [],
    rowsPerPage:10,
    page:0,
    usersCount:0,
    userDialog: {
        openUserDialog: false,
        userDialogInit:null,
        userDialogMessage:""
    }
    
}

const ADMIN_SET_USERS = "ADMIN_SET_USERS";
const ADMIN_SET_USERSCOUNT = "ADMIN_SET_USERSCOUNT";
const ADMIN_SET_ROWSPERPAGE = "ADMIN_SET_ROWSPERPAGE";
const ADMIN_SET_PAGE = "ADMIN_SET_PAGE";

const ADMIN_USERDIALOG_SET_OPEN = "ADMIN_USERDIALOG_SET_OPEN";
const ADMIN_USERDIALOG_SET_INITDATA = "ADMIN_USERDIALOG_SET_INITDATA";
const ADMIN_USERDIALOG_SET_MESSAGE = "ADMIN_USERDIALOG_SET_MESSAGE";

const adminReducer = (state = initialState, action) => {

    switch (action.type) {
        case ADMIN_SET_USERS: {
            
            return {...state, users: action.users}
 
        }
        case ADMIN_SET_USERSCOUNT: {
            
            return {...state, usersCount: action.count}
 
        }
        case ADMIN_SET_ROWSPERPAGE: {
            
            return {...state, rowsPerPage: action.rows}
 
        }
        case ADMIN_SET_PAGE: {
            
            return {...state, page: action.page}
 
        }
        case ADMIN_USERDIALOG_SET_OPEN: {
            
            return {...state, userDialog:{...state.userDialog, openUserDialog:action.value}}
 
        }
        case ADMIN_USERDIALOG_SET_INITDATA: {
            
            return {...state, userDialog:{...state.userDialog, userDialogInit:action.data}}
 
        }
        case ADMIN_USERDIALOG_SET_MESSAGE: {
            
            return {...state, userDialog:{...state.userDialog, userDialogMessage:action.message}}
 
        }
        default: return state;
    }
}

const setUsers = (users) => ({type: ADMIN_SET_USERS, users});
const setUsersCount = (count) => ({type: ADMIN_SET_USERSCOUNT, count});
export const setRowsPerPage = (rows) => ({type: ADMIN_SET_ROWSPERPAGE, rows});
export const setPage = (page) => ({type: ADMIN_SET_PAGE, page});
export const setOpenUserDialog = (value) => ({type: ADMIN_USERDIALOG_SET_OPEN, value});
const setInitDataUserDialog = (data) => ({type: ADMIN_USERDIALOG_SET_INITDATA, data});
const setMessageUserDialog = (message) => ({type: ADMIN_USERDIALOG_SET_MESSAGE, message});

export const getUsers = (page, rows)=>{
    return async (dispatch, getState)=>{

        await dispatch(updateAccessToken());
        const token = getState().appReducer.accessToken;

        try {
            const response = await authAPI.userList(token.access_token, page, rows);
            if (response.errors.length===0) {
                dispatch(setUsersCount(response.result.count));
                dispatch(setUsers(response.result.users));
            }
           
        } catch(err) {
            console.log(err);
        }
    }
}

export const getUserData = (userId)=>{
    return async (dispatch, getState)=>{

        if (userId<0) {
            dispatch(setInitDataUserDialog(null));
            dispatch(setOpenUserDialog(true));
        } else {

            await dispatch(updateAccessToken());
            const token = getState().appReducer.accessToken;

            try {
                const response = await authAPI.userData(token.access_token,userId);
                if (response.errors.length===0) {
                    dispatch(setInitDataUserDialog(response.result));
                    dispatch(setOpenUserDialog(true));
                }
                
            } catch(err) {
                console.log(err);
            
            }
        }
    }
}

export const changeUserData = (data)=>{
    return async (dispatch, getState)=>{

        await dispatch(updateAccessToken());
        const token = getState().appReducer.accessToken;
        const { page, rowsPerPage } = getState().adminReducer;

        let response = {};

        for (var key in data) {
            if (key==='username') data.username=data.username.replace(/[^+\d]/g, '');
        }

        
        console.log(data);
        
       

        try {
            
            if (data.id) {
                response = await authAPI.changeUser(token.access_token, data);
            } else {
                response = await authAPI.addUser(token.access_token, data);
            }

            

            if (response.errors.length===0) {
                dispatch(setOpenUserDialog(false));
                dispatch(getUsers(page, rowsPerPage));
            } else {
                dispatch(setMessageUserDialog(response.errors[0].msg));
                setTimeout(() => dispatch(setMessageUserDialog("")), 5000);
            }
           
        } catch(err) {
            dispatch(setMessageUserDialog("Error"));
        }
    }
}

export default adminReducer;